import { useMutation, useQueryClient } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";

const saveStep = async (data) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);
  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateStepRecording&companyid=${user.companyid}`,
    data,
  );

  return response.data;
};

const useSaveStepQuery = (options = {}) => {
  return useMutation({
    mutationFn: saveStep,
    ...options,
  });
};

export default useSaveStepQuery;
